/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ./images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('./images', true)
// const imagePath = (name) => images(name, true)

import { v4 as uuidv4 } from "uuid";

const getCookie = (name) => {
  const match = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${name}=`));
  return match ? match.split("=")[1] : null;
};

const setCookie = (name, value, days) => {
  const date = new Date();
  date.setDate(date.getDate() + days);
  document.cookie = `${name}=${value}; path=/; expires=${date.toUTCString()}`;
};

const syncVisitorID = () => {
  let cookieID = getCookie("XVisitorID");
  let localID = localStorage.getItem("XVisitorID");

  // If both exist and are different, prefer cookie and sync to localStorage
  if (cookieID && localID && cookieID !== localID) {
    localStorage.setItem("XVisitorID", cookieID);
    localID = cookieID;
  }

  // If only one exists, sync to the other
  if (cookieID && !localID) {
    localStorage.setItem("XVisitorID", cookieID);
    localID = cookieID;
  } else if (!cookieID && localID) {
    setCookie("XVisitorID", localID, 365);
    cookieID = localID;
  }

  // If neither exists, generate and sync both
  if (!cookieID && !localID) {
    const fingerprint = uuidv4();
    setCookie("XVisitorID", fingerprint, 365);
    localStorage.setItem("XVisitorID", fingerprint);
    return fingerprint;
  }

  return cookieID || localID;
};

(async () => {
  const currentVisitorID = syncVisitorID();
  console.log("Current Visitor ID:", currentVisitorID);
})();

const jQuery = require("jquery");
global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;

const bootstrap = require("bootstrap");
window.bootstrap = bootstrap;
global.bootstrap = bootstrap;

import { WOW } from "wowjs";
window.WOW = WOW;
global.WOW = WOW;

const sal = require("sal.js");
window.sal = sal;
global.sal = sal;

const Cookies = require("js-cookie");
window.Cookies = Cookies;
global.Cookies = Cookies;

const feather = require("../theme/vendor/feather.min");
window.feather = feather;
global.feather = feather;

require("../theme/vendor/modernizr.min");
require("../theme/vendor/waypoint.min");
require("../theme/vendor/counterup.min");
require("../theme/vendor/masonry");
require("../theme/vendor/imageloaded");
require("../theme/vendor/magnify.min");
require("../theme/vendor/lightbox");
require("../theme/vendor/slick.min");
require("../theme/vendor/easypie");
require("../theme/vendor/text-type");
require("../theme/vendor/jquery.style.swicher");
require("../theme/vendor/bootstrap-select.min");
require("../theme/vendor/backto-top");
require("../theme/vendor/jquery-one-page-nav");
require("../theme/main");

import ReactOnRails from "react-on-rails";
import HomeSlider from "../bundles/HomeSlider/HomeSlider";
import MarketplaceFlowSlider from "../bundles/MarketplaceFlowSlider/MarketplaceFlowSlider";
import SignApp from "../bundles/SignApp/SignApp";
import StackSlider from "../bundles/StackSlider/StackSlider";
import PricingSlider from "../bundles/PricingSlider/PricingSlider";
import MuxCard from "../bundles/MuxCard/MuxCard";
import MuxWidePlayer from "../bundles/MuxWidePlayer/MuxWidePlayer";

ReactOnRails.register({
  HomeSlider,
  MarketplaceFlowSlider,
  SignApp,
  StackSlider,
  PricingSlider,
  MuxCard,
  MuxWidePlayer,
});
